"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getGiftCardList: ()=>getGiftCardList,
    getGiftCard: ()=>getGiftCard,
    getGiftCardLocationList: ()=>getGiftCardLocationList,
    checkGiftCardBalance: ()=>checkGiftCardBalance,
    createGiftCard: ()=>createGiftCard,
    activateGiftCardWithPoints: ()=>activateGiftCardWithPoints,
    activateGiftCard: ()=>activateGiftCard,
    createGiftCardWithPoints: ()=>createGiftCardWithPoints,
    reloadGiftCard: ()=>reloadGiftCard,
    updateGiftCard: ()=>updateGiftCard,
    updateGiftCardBalances: ()=>updateGiftCardBalances,
    pointsToCashGiftCard: ()=>pointsToCashGiftCard,
    getGiftCardPaymentList: ()=>getGiftCardPaymentList,
    createGiftCardPayment: ()=>createGiftCardPayment,
    deleteGiftCardPayment: ()=>deleteGiftCardPayment,
    getLocationList: ()=>getLocationList,
    getPointToCash: ()=>getPointToCash,
    getRecievedGiftCard: ()=>getRecievedGiftCard,
    deleteGiftCards: ()=>deleteGiftCards,
    useRecievedGiftCard: ()=>useRecievedGiftCard,
    useGetGiftCardList: ()=>useGetGiftCardList,
    useGetGiftCard: ()=>useGetGiftCard,
    useGetPointToCash: ()=>useGetPointToCash,
    useGetGiftCardLocationList: ()=>useGetGiftCardLocationList,
    useGetGiftCardPaymentList: ()=>useGetGiftCardPaymentList,
    useLocationListQuery: ()=>useLocationListQuery,
    useCheckGiftCardBalance: ()=>useCheckGiftCardBalance,
    useCreateGiftCard: ()=>useCreateGiftCard,
    useCreateGiftCardWithPoints: ()=>useCreateGiftCardWithPoints,
    useActivateGiftCard: ()=>useActivateGiftCard,
    useActivateGiftCardWithPoints: ()=>useActivateGiftCardWithPoints,
    useReloadGiftCard: ()=>useReloadGiftCard,
    useUpdateGiftCard: ()=>useUpdateGiftCard,
    useDeleteGiftCards: ()=>useDeleteGiftCards,
    useUpdateGiftCardBalances: ()=>useUpdateGiftCardBalances,
    usePointsToCashGiftCard: ()=>usePointsToCashGiftCard,
    useCreateGiftCardPayment: ()=>useCreateGiftCardPayment,
    useDeleteGiftCardPayment: ()=>useDeleteGiftCardPayment
});
const _reactQuery = require("react-query");
const _index = require("./../../index");
const _react = require("react");
const emptyObj = {
    data: [],
    refetch: ()=>{},
    isLoading: true
};
const getGiftCardList = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards?member_id=${payload.member_id}`, opts);
    return response;
};
const getGiftCard = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/${payload.id}?member_id=${payload.member_id}`, opts);
    return response.gift_card;
};
const getGiftCardLocationList = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/location_list?member_id=${payload.member_id}`, opts);
    return response.location_list;
};
const checkGiftCardBalance = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/check_balance?card_number=${payload.card_number}&card_pin=${payload.card_pin}&member_id=${payload.member_id}`, opts);
    return response.balance;
};
const createGiftCard = async (payload, opts)=>{
    const cardBalance = payload.balance || await checkGiftCardBalance({
        card_number: payload.card_number,
        card_pin: payload.card_pin,
        member_id: payload.member_id
    });
    const balance = parseFloat(cardBalance.replace(/\$/g, ''));
    if (balance && !Number.isNaN(balance)) {
        const response = await _index.api.post(`/native_app/v2/gift_cards?member_id=${payload.member_id}`, {
            ...payload,
            balance
        }, opts);
        return response.gift_card;
    }
};
const activateGiftCardWithPoints = async (payload, opts)=>{
    await _index.api.post(`/native_app/v2/gift_cards/activate_with_points?member_id=${payload.member_id}`, {
        ...payload
    }, opts);
};
const activateGiftCard = async (payload, opts)=>{
    const response = await _index.api.post(`/native_app/v2/gift_cards/activate?member_id=${payload.member_id}`, payload, opts);
    return response.gift_card;
};
const createGiftCardWithPoints = async (payload, opts)=>{
    await _index.api.post(`/native_app/v2/gift_cards/create_with_points?member_id=${payload.member_id}`, payload, opts);
};
const reloadGiftCard = async (payload, opts)=>{
    const response = await _index.api.post(`/native_app/v2/gift_cards/reload?member_id=${payload.member_id}`, payload, opts);
    return response.gift_card;
};
const updateGiftCard = async (payload, opts)=>{
    const response = await _index.api.put(`/native_app/v2/gift_cards/${payload.id}?member_id=${payload.member_id}`, payload, opts);
    return response.gift_card;
};
const updateGiftCardBalances = async (payload, opts)=>{
    const response = await _index.api.put(`/native_app/v2/gift_cards/update_gift_cards_balances?member_id=${payload.member_id}`, opts);
    return response;
};
const pointsToCashGiftCard = async (payload, opts)=>{
    const response = await _index.api.put(`/native_app/v2/gift_cards/points_to_cash?member_id=${payload.member_id}`, payload, opts);
    return response.gift_card;
};
const getGiftCardPaymentList = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_card_payments?member_id=${payload.member_id}`, opts);
    return response;
};
const createGiftCardPayment = async (payload, opts)=>{
    const response = await _index.api.post(`/native_app/v2/gift_card_payments?member_id=${payload.member_id}`, payload, opts);
    return response.payment;
};
const deleteGiftCardPayment = async (payload, opts)=>{
    const response = await _index.api.patch(`/native_app/v2/gift_card_payments/soft_delete?member_id=${payload.member_id}`, payload, opts);
    return response.payment;
};
const getLocationList = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/location_list?member_id=${payload.member_id}`, opts);
    return response;
};
const getPointToCash = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/points_to_cash?member_id=${payload.member_id}`, opts);
    return response;
};
const getRecievedGiftCard = async (payload, opts)=>{
    const response = await _index.api.get(`native_app/v2/gift_cards/received_list?member_id=${payload.member_id}`, opts);
    return response;
};
const deleteGiftCards = async (payload, opts)=>{
    const response = await _index.api.delete(`native_app/v2/gift_cards/destroy_all_depleted?member_id=${payload.member_id}`, opts);
    return response;
};
const useRecievedGiftCard = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCard', ({ signal  })=>getRecievedGiftCard(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardList = (queryOptions = {})=>{
    const { member , giftCards , setGiftCards , setReceivedGiftCard  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    return (0, _reactQuery.useQuery)('giftCardList', ({ signal  })=>getGiftCardList(payload, {
            signal
        }), {
        ...queryOptions,
        onSuccess: (data)=>{
            setGiftCards((previousState)=>{
                setReceivedGiftCard(previousState.length !== 0 && previousState.length < data.length);
                return data;
            });
        }
    });
};
const useGetGiftCard = (id, queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString(),
        id
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCard', ({ signal  })=>getGiftCard(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetPointToCash = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('pointToCash', ({ signal  })=>getPointToCash(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardLocationList = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCardLocationList', ({ signal  })=>getGiftCardLocationList(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardPaymentList = (queryOptions = {})=>{
    const { member , setGiftCardPaymentList  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCardPaymentList', ({ signal  })=>getGiftCardPaymentList(payload, {
            signal
        }), {
        ...queryOptions,
        onSuccess: (data)=>{
            setGiftCardPaymentList(data);
        }
    });
};
const useLocationListQuery = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('locationList', ({ signal  })=>getLocationList(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useCheckGiftCardBalance = (card_number, card_pin, queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString(),
        card_number,
        card_pin
    };
    if (!payload || !card_number || !card_pin) {
        return {
            data: '',
            refetch: ()=>{}
        };
    }
    return (0, _reactQuery.useQuery)('checkGiftCardBalance', ({ signal  })=>checkGiftCardBalance(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useCreateGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>createGiftCard(payload), {
        ...queryOptions
    });
};
const useCreateGiftCardWithPoints = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>createGiftCardWithPoints(payload), {
        ...queryOptions
    });
};
const useActivateGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>activateGiftCard(payload), {
        ...queryOptions
    });
};
const useActivateGiftCardWithPoints = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>activateGiftCardWithPoints(payload), {
        ...queryOptions
    });
};
const useReloadGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>reloadGiftCard(payload), {
        ...queryOptions
    });
};
const useUpdateGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updateGiftCard(payload), {
        ...queryOptions
    });
};
const useDeleteGiftCards = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>deleteGiftCards(payload), {
        ...queryOptions
    });
};
const useUpdateGiftCardBalances = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updateGiftCardBalances(payload), {
        ...queryOptions
    });
};
const usePointsToCashGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>pointsToCashGiftCard(payload), {
        ...queryOptions
    });
};
const useCreateGiftCardPayment = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>createGiftCardPayment(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            console.log(data, 'THIS IS CREATe GIFT CARD PAYMENT');
        }
    });
};
const useDeleteGiftCardPayment = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>deleteGiftCardPayment(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            console.log(data, 'THIS IS DELETE GIFT CARD PAYMENT');
        }
    });
};
const useGiftCardScreen = ()=>{
    (0, _react.useEffect)(()=>{});
};
